import React from 'react';
import { Group } from '@vx/group';
import { scaleLinear } from '@vx/scale';
import { Point } from '@vx/point';
import { Line, LineRadial } from '@vx/shape';
import { max, min } from 'd3-array';
import { Text } from '@vx/text';
import "../components/Radar.css";

const ANG = 360;

const calcAxis = length => {
    if (!length) return [];
    return new Array(length + 1)
        .fill(0)
        .map((v, i) => ({ angle: i * (ANG / length) }));
};

function calcPoints(length, radius) {
    const step = Math.PI * 2 / length;
    return new Array(length).fill(0).map((v, i) => {
        return {
            x: radius * Math.sin(i * step),
            y: radius * Math.cos(i * step),
        };
    });
}

function calcCoordinates(data, scale, access) {
    const step = Math.PI * 2 / data.length;
    const points = new Array(data.length).fill({});
    const pointStr = new Array(data.length + 1)
        .fill('')
        .reduce((res, v, i) => {
            if (i > data.length) return res;
            const x = scale(access(data[i - 1])) * Math.sin(i * step);
            const y = scale(access(data[i - 1])) * Math.cos(i * step);
            points[i - 1] = { x, y };
            return (res += `${x},${y} `);
        });

    points.str = pointStr;
    return points;
}

export default ({
    width,
    height,
    events = false,
    margin,
    levels = 5,
    radarData
}) => {
    margin = { right: width / 8, bottom: 0, top: 0 }
    radarData.sort((a, b) => {
        if (a.level < b.level) return 1;
        if (a.level > b.level) return -1;
        return 0
    })

    if (width < 10) return null;

    const xMax = width - (width / 8) - (width / 8);
    const yMax = height - (width / 8) - (width / 8);

    const webs = calcAxis(radarData.length);
    const radius = min([xMax, yMax]) / 2;
    const points = calcPoints(radarData.length, radius);

    // const x = d => d.skill;
    const y = d => d.level;

    const rScale = scaleLinear({
        range: [0, Math.PI * 2],
        domain: [ANG, 0],
    });

    const yScale = scaleLinear({
        range: [0, radius],
        domain: [0, max(radarData, y)],
    });

    const polyPoints = calcCoordinates(radarData, yScale, y);

    return (
        <figure className='radar'>
            <svg width={width} height={height} >
                <Group top={height / 2} left={width / 2}>
                    {[...new Array(levels)].map((v, i) => (
                        <LineRadial
                            data={webs}
                            key={`web-${i}`}
                            angle={d => rScale(d.angle)}
                            radius={(i + 1) * radius / levels}
                            fill="none"
                            stroke="#fff"
                            strokeWidth={2}
                            strokeOpacity={0.2}
                            strokeLinecap="round"
                        />
                    ))}
                    {[...new Array(radarData.length)].map((v, i) => (
                        <Line
                            key={`line-${i}`}
                            from={new Point({ x: 0, y: 0 })}
                            to={new Point({ x: points[i].x, y: points[i].y })}
                            stroke="#fff"
                            strokeOpacity={0.2}
                            strokeWidth={2}
                        />
                    ))}
                    <polygon
                        points={polyPoints.str}
                        fill="#fff"
                        fillOpacity="0.1"
                        stroke="#fff"
                        strokeOpacity="0.1"
                        strokeWidth={2}
                    />
                    {polyPoints.map((v, i) => (
                        <circle
                            key={`point-${i}`}
                            cx={v.x}
                            cy={v.y}
                            r={5}
                            fill={radarData[i].color}
                            className="dots"
                        />
                    ))}
                    {
                        polyPoints.map((v, i) => (
                            <Text
                                key={`text-${i}`}
                                fill={radarData[i].color}
                                x={v.x - 35 }
                                y={v.y - 5}
                            >
                                { radarData[i].level }
                            </Text>
                        ))
                    }
                </Group>
            </svg>
        </figure>
    );
};


// WEBPACK FOOTER //
// ./src/components/Radar.js